import React, {useCallback, useEffect, useState} from "react";
import {Avatar, Button, Input, List, message, Popconfirm, Row, Space, Tag, theme, Typography} from "antd";
import {Routes, Route, Link} from "react-router-dom";
import AdminLayout from "../../components/admin-layout";
import {deleteUser, getUsers} from "../../services/users";
import {updatedSince} from "../../utils";
import {DeleteOutlined} from "@ant-design/icons";
import CreateUser from "../user-create";
import EditUser from "../user-edit";
import { toast } from 'sonner'

export default function Users() {
  return (
    <AdminLayout>
      <Routes>
        <Route index path={'/'} element={<ListUsers/>}/>
        <Route index path={'/:id'} element={<EditUser/>}/>
        <Route index path={'/create'} element={<CreateUser/>}/>
      </Routes>
    </AdminLayout>
  )
}

function ListUsers() {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(8);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);

  const reload = useCallback(async (query) => {
    setLoading(true);
    const {data, total} = await getUsers({page, perPage, search: query !== undefined ? query : search, searchField: 'name'}).finally(() => setLoading(false));
    setUsers(data);
    setTotal(total);
  }, [page, perPage, search, setUsers, setTotal, setLoading]);

  useEffect(() => {
    reload().catch(() => toast.error("Falha ao carregar usuários"))
  }, [page, perPage])

  useEffect(() => {
    const timeout = setTimeout(() => {
      reload(search).catch(() => toast.error("Falha ao buscar usuários"))
    }, 300)

    return () => clearTimeout(timeout)
  }, [search, reload]);

  return (
    <>
      <List
        orientation={'left'}
        itemLayout={'horizontal'}
        dataSource={users}
        loading={loading}
        header={
          <Row justify={'space-between'}>
            <Typography.Title level={3}>Usuários</Typography.Title>
            <Space direction={'horizontal'}>
              <Input.Search placeholder={'Pesquisa por nome'}
                            onSearch={(search) => setSearch(search)}
                            onChange={({target}) => setSearch(target.value)}/>
              <Link to={'/users/create'}>
                <Button type="primary">
                  Criar
                </Button>
              </Link>
            </Space>
          </Row>
        }
        pagination={{
          position: "bottom",
          align: "end",
          onChange: (page, perPage) => {
            setPage(page);
            setPerPage(perPage);
          },
          total,
          pageSize: perPage,
          current: page
        }}
        renderItem={(item) => <UserContainer reload={reload} data={item}/>}
      />
    </>
  );
}

function UserContainer({data, reload}) {
  const {
    token: {colorPrimaryBg, colorPrimaryActive},
  } = theme.useToken();

  return (
    <List.Item
      actions={[
        <Link to={`${data?.id}`}>
          <Button type={'text'}>Editar</Button>
        </Link>,
        <Popconfirm
          title="Você tem certeza?"
          description="Essa ação vai deletar o usuário ele perderá acesso a plataforma"
          onConfirm={async () => {
            await deleteUser(data?.id);
            await reload().catch(() => toast.error("Falha ao carregar usuários"));
          }}
          cancelText={'Cancelar'}>
          <Button danger type={'text'} style={{marginLeft: '1rem'}} icon={<DeleteOutlined/>}/>
        </Popconfirm>
      ]}
    >
      <List.Item.Meta
        title={data?.name}
        avatar={<Avatar size={'large'} style={{
          backgroundColor: colorPrimaryBg,
          color: colorPrimaryActive
        }}>{data?.name?.charAt(0)}</Avatar>}
        description={"Criado á " + updatedSince(new Date(data.createdAt))}
      />
    </List.Item>
  )
}
